module.exports = __webpack_public_path__ + "static/img/12.582c13e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/eng/12.png
// module id = NGGh
// module chunks = 0